import axios from "axios";
import { EventBus } from "./event-bus.js";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import {} from "@/enums";
import dayjs from "dayjs";

// const API_URL_BASE = 'http://localhost:8080/v1';
// const API_URL_BASE = 'http://localhost:30080/v1';
// const API_URL_BASE = 'http://10.10.21.28:30080/v1';
// const API_URL_BASE = 'http://localhost:1236/v1';
// const API_URL_BASE = 'https://dev-axiosInstance.cereb.ai/v1';
const API_URL_BASE = process.env.VUE_APP_API_URL_BASE;
const NAEMESPACE_ID = "api-portal";

// const API_URL_BASE = 'http://platform-demo-v2.cereb.ai/#/';
// const TIMEZONE = 'Asia/Hong_Kong'

const axiosInstance = axios.create({
  baseURL: API_URL_BASE,
  timeout: 60000,
  withCredentials: true,
});

export const requestInterceptor = (config) => {
  // 请求时将token加入到headers
  if (localStorage.token) {
    config.headers["Authorization"] = "Bearer " + localStorage.token;
    config.headers["X-Namespace-Id"] = NAEMESPACE_ID;
  }
  return config;
};

export const requestErrorInterceptor = (error) => {
  console.log("request err: " + error);
  return Promise.reject(error);
};

export const responseInterceptor = (response) => {
  if ((response.status === 400 || response.status === 403) && response.data) {
    throw response.data;
  }
  return response.data;
};

export const responseErrorInterceptor = (error) => {
  if (error && error.response && error.response.status === 401) {
    // 跳转登录页
    EventBus.$emit("logout");
    return Promise.reject("unauthorized");
  }
  console.log("response err: " + error);
  return Promise.reject(error);
};

// ==========>请求拦截
axiosInstance.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);
// ==========>响应拦截
axiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

export function login(username, password) {
  return axiosInstance.post("/login/username", {
    username: username,
    password: password,
  });
}

export function loginEmail(email, password) {
  return axiosInstance.post("/login/email", {
    email: email,
    password: password,
  });
}

export function verifyLogin(msgId, verificationCode) {
  let params = {
    msgId: msgId,
    verificationCode: verificationCode,
  };
  return axiosInstance.post("/login/verify_verification_code", null, {
    params: params,
  });
}

export function updateVerifyLogin(userDetailVo) {
  let params = {
    verifyLogin: userDetailVo.verifyLogin,
  };
  return axiosInstance.post(
    "/user/detail/" + userDetailVo.id + "/verify_login",
    null,
    {
      params: params,
    }
  );
}

export function signup(username, email, password) {
  return axiosInstance.post("/signup/username", {
    username: username,
    email: email,
    password: password,
  });
}

export function resetPasswordRequest(email) {
  return axiosInstance.post("/password/request_reset", {
    email: email,
  });
}

export function resetPassword(email, newPassword, confirmPassword, code) {
  return axiosInstance.post("/password/reset", {
    email: email,
    code: code,
    newPassword: newPassword,
    confirmPassword: confirmPassword,
  });
}

export function getUserDetail() {
  return axiosInstance.get("/user/detail/");
}

export function getUserWidgets() {
  return axiosInstance.get("/dashboard/widgets");
}

export function getUserWidgetByWidgetId(widgetId) {
  return axiosInstance.get("/dashboard/widgets" + widgetId);
}

export class GetEventRequest {
  type = undefined;
  sinceTime = undefined;
  search = undefined;
  offset = 0;
  limit = 20;
  order = undefined;
  prop = undefined;
  constructor(model = {}) {
    Object.assign(this, model);
  }
}

/**
 * 仪表盘事件返回模型
 * @typedef {Object} DashboardEvent
 * @property {number} id - 事件ID
 * @property {string} userId - 用户ID
 * @property {string} name - 事件名称
 * @property {string} type - 事件类型 (如 "alert")
 * @property {string} event - 事件描述
 * @property {string|null} executionId - 执行ID，可能为null
 * @property {number} timestamp - 时间戳
 * @property {number} level - 事件等级
 * @property {number} status - 事件状态
 * @property {string} deviceKey - 设备Key
 * @property {string} assetName - 资产名称
 * @property {Object|null} tagInfo - 标签信息，可能为null
 * @property {Object|null} agentInfo - 智能体信息，可能为null
 *   @property {string} [agentInfo.agentId] - 智能体ID
 *   @property {string} [agentInfo.conversationId] - 会话ID
 *   @property {any} [agentInfo.reply] - 智能体回复内容
 * @property {AiAuditRecord|null} aiAudit - AI审核信息，可能为null，结构见 AiAuditRecord
 */

/**
 * @returns {Promise<DashboardEvent>}
 */
export function getEvents(params = new GetEventRequest()) {
  return axiosInstance.get("/dashboard/events", {
    params,
  });
}

/**
 * @return {Promise<{0:number,1:number,2:number,total:number}>}
 */
export function getEventInsights() {
  return axiosInstance.get("/dashboard/events/insight");
}

export function getNotificationInsight() {
  return axiosInstance.get("/dashboard/notification/insight");
}

/**
 * 更新仪表盘事件（标签/状态）
 * @param {Object} params
 * @param {Array<string>} params.eventIds 事件ID数组
 * @param {Object} [params.tagInfo] 标签信息，如 { type, note }
 * @param {number} [params.status] 事件状态
 * @returns {Promise}
 */
export function updateDashboardEvent({ eventIds = [], tagInfo, status } = {}) {
  const data = { eventIds };
  if (tagInfo) data.tagInfo = tagInfo;
  if (typeof status !== "undefined") data.status = status;
  return axiosInstance.post("dashboard/event/update", data);
}

export function createAsset(assetVo) {
  return axiosInstance.post("/assets", {
    assetVo: assetVo,
  });
}

/**
 * {name,connectName}
 */
export function createThirdPartyAsset(model) {
  return axiosInstance.post("/assets/third_party", model);
}

export function deleteThirdPartyAsset(id) {
  return axiosInstance.delete(`/assets/third_party/${id}`);
}

export function getAllAssetVo() {
  return axiosInstance.get("/assets");
}

export function deleteAsset(assetId) {
  return axiosInstance.delete("/assets" + assetId);
}

// 地图上新增设备
export const setAssetAttr = (assetId, params) => {
  return axiosInstance.post(`/assets/${assetId}/attr`, params);
};

// 地图上删除设备
export const deleteAssetAttr = (assetId, params) => {
  // https://masteringjs.io/tutorials/axios/delete-with-body
  // https://stackoverflow.com/questions/51069552/axios-delete-request-with-request-body-and-headers
  return axiosInstance.delete(`/assets/${assetId}/attr`, { data: params });
};

export function getDevicesDataByAssetIds(assetIds) {
  let params = {
    // assetId以逗号分隔
    assetIds: assetIds,
  };
  return axiosInstance.get("/assets/assets_data", {
    params,
  });
}

export function getAllConnect() {
  return axiosInstance.get("/connects");
}

export function cmdConnectInstance(instanceId, cmd) {
  return axiosInstance.put(
    "/connects/connect_instances/" + instanceId + "/cmd/" + cmd
  );
}

export function createConnectInstance(connectInstanceVo) {
  let stopped = false;
  if (
    connectInstanceVo &&
    connectInstanceVo.stopped &&
    connectInstanceVo.stopped === true
  ) {
    stopped = true;
  }
  return axiosInstance.post(
    "/connects/" + connectInstanceVo.connectId + "/instances",
    {
      name: connectInstanceVo.name,
      stopped: stopped,
      attr: connectInstanceVo.attr,
    }
  );
}

export function updateConnectInstance(
  instanceId,
  connectInstanceVo,
  deleteAssets
) {
  let params = {
    deleteAssets: deleteAssets,
  };
  return axiosInstance.put(
    "/connects/" + connectInstanceVo.connectId + "/instances/" + instanceId,
    {
      instanceId: instanceId,
      name: connectInstanceVo.name,
      connectId: connectInstanceVo.connectId,
      attr: connectInstanceVo.attr,
    },
    {
      params: params,
    }
  );
}

export function confirmConnectInstance(connectInstanceVo, selectedDevices) {
  return axiosInstance.post(
    "/connects/" +
      connectInstanceVo.connectId +
      "/instances/" +
      connectInstanceVo.instanceId +
      "/confirm",
    selectedDevices
  );
}

export function getConnectInstanceListByConnectId(connectId) {
  return axiosInstance.get("/connects/" + connectId + "/instances");
}

export function getConnectInstanceVo(connectId, instanceId) {
  return axiosInstance.get(
    "/connects/" + connectId + "/instances/" + instanceId
  );
}

export function deleteConnectInstance(connectId, instanceId) {
  return axiosInstance.delete(
    "/connects/" + connectId + "/instances/" + instanceId
  );
}

export function check_salto_credential(salto_username, salto_password) {
  let params = {
    salto_username: salto_username,
    salto_password: salto_password,
  };
  return axiosInstance.get("/salto/integration/check_credential", {
    params,
  });
}

export function list_sites(salto_username, salto_password) {
  let params = {
    salto_username: salto_username,
    salto_password: salto_password,
  };
  return axiosInstance.get("/salto/integration/sites", {
    params,
  });
}

export function list_IQs(salto_username, salto_password, site_id) {
  let params = {
    salto_username: salto_username,
    salto_password: salto_password,
  };
  return axiosInstance.get(
    "/salto/integration/sites/" + unescape(site_id) + "/iqs",
    {
      params,
    }
  );
}

export function get_salto_iq_secret(
  salto_username,
  salto_password,
  site_id,
  iq_id,
  otp
) {
  let params = {
    salto_username: salto_username,
    salto_password: salto_password,
    site_id: site_id,
    iq_id: iq_id,
    otp: otp,
  };
  return axiosInstance.get("/salto/integration/get_iq_secret", {
    params,
  });
}

export function check_uhoo_credential(uhoo_client_id) {
  let params = {
    client_id: uhoo_client_id,
  };
  return axiosInstance.get("/uhoo/integration/check_credential", {
    params,
  });
}

export function getLifeSmartUrl() {
  return axiosInstance.get("/integration/lifesmart/get_auth_url");
}

export function getSonosUrl() {
  return axiosInstance.get("/sonos/integration/get_auth_url");
}
export function getSonosHouseholds(state) {
  return axiosInstance.get("/sonos/integration/households", {
    params: { state: state },
  });
}

export function webSocketClient(websocketUrl) {
  let url = API_URL_BASE + websocketUrl;
  let socket = new SockJS(url);
  const client = Stomp.over(socket);
  // 设置心跳（单位毫秒）
  client.heartbeat.outgoing = 4000; // 发送心跳
  client.heartbeat.incoming = 4000; // 接收心跳
  client.debug = () => {}; // 关闭日志
  return client;
}

export function check_coolautomation_credential(
  coolautomation_username,
  coolautomation_password
) {
  let params = {
    coolautomation_username: coolautomation_username,
    coolautomation_password: coolautomation_password,
  };
  return axiosInstance.get("/coolautomation/integration/check_credential", {
    params,
  });
}

export function check_airthongs_credential(
  airthings_client_id,
  airthings_client_secret
) {
  let params = {
    airthings_client_id: airthings_client_id,
    airthings_client_secret: airthings_client_secret,
  };
  return axiosInstance.get("/airthings/integration/check_credential", {
    params,
  });
}

export function check_kuju_credential(kuju_username, kuju_password) {
  let params = {
    kuju_username: kuju_username,
    kuju_password: kuju_password,
  };
  return axiosInstance.get("/kuju/integration/check_credential", {
    params,
  });
}

export function get_kuju_gateway_sn(kuju_username, kuju_password) {
  let params = {
    kuju_username: kuju_username,
    kuju_password: kuju_password,
  };
  return axiosInstance.get("/kuju/integration/gateway_sn", { params });
}

export function check_moodo_credential(moodo_email, moodo_password) {
  let params = {
    moodo_email: moodo_email,
    moodo_password: moodo_password,
  };
  return axiosInstance.get("/moodo/integration/check_credential", {
    params,
  });
}

// #region tuya
export function check_tuya_credential(tuyaAccessId, tuyaAccessSecret) {
  let params = {
    tuya_access_id: tuyaAccessId,
    tuya_access_secret: tuyaAccessSecret,
  };
  return axiosInstance.get("/tuya/integration/check_credential", {
    params,
  });
}
// #endregion

export function checkAciistExistDevice(connectInstanceVo) {
  let params = {
    connectInstanceVo: connectInstanceVo,
  };
  return axiosInstance.get("/aciist/integration/check_device_exist", {
    params,
  });
}

// 获取二维码
export function getShadowQrcode(id, title = "") {
  return axiosInstance.get(`/virtual_controller/${id}/qrcode`, {
    responseType: "blob",
    params: {
      title: title,
    },
  });
  // return API_URL_BASE + '/virtual_controller/' + id + '/qrcode/' + type
}

// 创建-->返回二维码
export function createVirtualController(data, logo) {
  var form = new FormData();
  form.append("json", JSON.stringify(data));
  form.append("logo", logo);
  return axiosInstance.post("/virtual_controller", form, {
    "Content-Type": "multipart/form-data;charse=UTF-8",
  });
}

// 查询-->返回所有二维码信息
export function getVirtualControllerList(type) {
  return axiosInstance.get("/virtual_controller/" + type);
}

// 查询-->返回单个二维码Logo
export function getVirtualControllerLogo(id) {
  return API_URL_BASE + "/public/virtual_controller/" + id + "/logo";
  // return instance.get('/public/virtual_controller/' + id + '/logo')
}

// 删除-->返回所有二维码信息
export function deleteVirtualController(id) {
  return axiosInstance.delete("/virtual_controller/" + id);
}

// 编辑-->返回成功失败
export function editVirtualController(id, data, logo) {
  var form = new FormData();
  form.append("json", JSON.stringify(data));
  form.append("logo", logo);
  return axiosInstance.post("/virtual_controller/" + id, form, {
    "Content-Type": "multipart/form-data;charse=UTF-8",
  });
}

export function createMqttShadowInstance(name) {
  let params = {
    shadowInstanceName: name,
  };
  return axiosInstance.post(
    "/virtual_controller/sub/mqtt_shadow/instance",
    {},
    {
      params: params,
    }
  );
}

export function getMqttShadowInstances() {
  return axiosInstance.get("/virtual_controller/sub/mqtt_shadow/instance");
}

export function deleteMqttShadowInstance(shadowInstanceId, mqttUsername) {
  let params = {
    shadow_instance_id: shadowInstanceId,
    mqtt_username: mqttUsername,
  };
  return axiosInstance.delete("/virtual_controller/sub/mqtt_shadow/instance", {
    params: params,
  });
}

export function createWebsocketShadowInstance(name) {
  let params = {
    shadowInstanceName: name,
  };
  return axiosInstance.post(
    "/virtual_controller/sub/websocket_shadow/instance",
    {},
    {
      params: params,
    }
  );
}

export function getWebsocketShadowInstances() {
  return axiosInstance.get("/virtual_controller/sub/websocket_shadow/instance");
}

export function deleteWebsocketShadowInstance(shadowInstanceId) {
  return axiosInstance.delete(
    "/virtual_controller/sub/websocket_shadow/instance/" + shadowInstanceId
  );
}

export function triggerEventAnalysis() {
  return axiosInstance.post("/dashboard/trigger_event_analysis");
}

export function controlDevice(assetId, command) {
  return axiosInstance.post("/assets/" + assetId + "/control_device", command);
}

/**
 * 新建对话
 */
export function newConversation(agents = [], promptPara) {
  const data = {
    agents: agents,
    platform: "web",
  };

  if (promptPara) {
    data["prompt_para"] = promptPara;
  }

  return axiosInstance.post("/conversations/v2", data);
}

/**
 * 发送消息
 */
export function sendMessage(conversationID, message) {
  const token = localStorage.token;
  return axiosInstance.post(
    `/conversations/v2/${conversationID}/messages`,
    message,
    {
      headers: {
        "user-cookie": `access-token=${token}`, //增加了一个user-cookie
      },
      params: {
        conversationID,
        autoreply: true,
      },
    }
  );
}

/**
 * 上传会话附件
 */
export async function uploadConversationAttachment(conversationId, file) {
  console.log(file);
  const formData = new FormData();
  formData.append("files", file);
  await axiosInstance.post(
    `/conversations/${conversationId}/attachements`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

/**
 * 获取消息
 */
export function getMessage(conversationID, sequenceNumber) {
  return axiosInstance.get(
    `/conversations/v2/${conversationID}/messages/${sequenceNumber}`
  );
}

export function getUserFromSession() {
  const json = sessionStorage.getItem("user");
  if (!json) {
    return null;
  }
  return JSON.parse(json);
}

/**
 * 删除对话
 */
export function deleteConversation(conversationID) {
  return axiosInstance.delete(`/conversations/${conversationID}`);
}

/**
 * 获取指定 agent 的会话列表
 * @param {string} agentId
 * @returns {Promise<Array<{
 *   platform: string,
 *   startTime: string,
 *   agents: string[],
 *   delegateAgents: string[],
 *   promptPara: object,
 *   maxConversationTime: string,
 *   maxDelegateMessageCount: string,
 *   title: string,
 *   websocketId: string,
 *   delegatedAgentId: string,
 *   delegatedMessageCount: string,
 *   conversationId: string,
 *   updateTime: string,
 * }>>}
 */
export async function getAgentConversations(agentId) {
  const response = await axiosInstance.get(`/agents/conversations/${agentId}`);
  return response?.conversation_list || [];
}

export function getRuleById(ruleId) {
  const userId = getUserFromSession().id;
  return axiosInstance.get(`/rule`, {
    params: { id: ruleId, "user-id": userId, _t: new Date().getTime() },
  });
}

export function getRules() {
  const userId = getUserFromSession().id;
  return axiosInstance.get(`/rules`, {
    params: {
      _t: new Date().getTime(),
      "user-id": userId,
    },
  });
}

export function addOrUpdateRule(rule, ruleId) {
  const userId = getUserFromSession().id;
  return axiosInstance.post(
    `/rule/addOrUpdate
`,
    rule,
    {
      params: {
        "user-id": userId,
        id: ruleId,
      },
    }
  );
}

export function deleteRule(ruleId) {
  const userId = getUserFromSession().id;
  return axiosInstance.post(`/rule/delete`, null, {
    params: {
      "user-id": userId,
      id: ruleId,
    },
  });
}

export function getAdminPlatformUsers(status, offset, limit) {
  let params = {
    status: status,
    offset: offset,
    limit: limit,
  };
  return axiosInstance.get("/admin/adminPlatform/users", {
    params,
  });
}

export function updateUserDetail(userDetail) {
  return axiosInstance.post("/admin/adminPlatform/users", userDetail);
}

export function updateStatus(id, status) {
  let params = {
    status: status,
  };
  return axiosInstance.post("/admin/users/" + id + "/status", {}, { params });
}

export function deleteUser(id) {
  return axiosInstance.delete("/admin/adminPlatform/users/" + id);
}

/**获取账号列表 */
export async function getUserAccounts({
  organizationId = "cereb-RLk6kY",
  name,
  siteId,
  offset,
  limit,
} = {}) {
  organizationId = getUserFromSession().organizationId || organizationId;
  const result = await axiosInstance.get(`/fission/auth-center/users`, {
    params: {
      organizationId,
      name,
      siteId,
      offset,
      limit,
    },
  });
  return result["data"];
}

/** 创建用户账号 */
export async function createOrUpdateUserAccount(user) {
  //  {
  //   "username": "Shawn",
  //   "alias": "Shawn",
  //   "role": "staff",
  //   "email": "1272172856@qq.com",
  //   "organizationId": "cereb-RLk6kY",
  //   "siteId": "cereb-RLk6kY-site-thtbMN",
  //   "status": "active",
  //   "dataPoints": "200",
  //   "plan": "premium"
  //  }
  const organizationId = getUserFromSession().organizationId;
  user["organizationId"] = organizationId;
  return axiosInstance.post(`/fission/auth-center/users`, [user]);
}

/** 删除用户账号 */
export async function deleteUserAccount(userId) {
  return axiosInstance.delete(`/fission/auth-center/users`, {
    params: {
      userId,
    },
  });
}

/** 获取全部门店 */
export async function getAllSites() {
  const organizationId = getUserFromSession().organizationId;
  const result = await axiosInstance.get("/fission/auth-center/sites", {
    params: {
      organizationId,
      offset: 1,
      limit: Number.MAX_SAFE_INTEGER,
    },
  });
  return result["data"]["list"] || [];
}

/** 创建或更新site */
export async function createOrUpdateSite(site) {
  //{
  //   "name": "hongkong-office",
  //   "address": "1, Dapu, Hongkong",
  //   "organizationId": "cereb-RLk6kY"
  //}
  const organizationId = getUserFromSession().organizationId;
  site["organizationId"] = organizationId;
  return axiosInstance.post("/fission/auth-center/sites", site);
}

/** 删除site */
export async function deleteSite(siteId) {
  return axiosInstance.delete(`/fission/auth-center/sites`, {
    params: {
      siteId,
    },
  });
}

export async function getUserOrganizationByEmail(userEmail) {
  const result = await axiosInstance.get("/fission/auth-center/organizations", {
    params: {
      userEmail,
    },
  });
  return result["organization"];
}

/**
 * 图表响应模型
 */
class DashboardChartDeviceDataResponse {
  deviceKey = "";
  timestamp = 0;
  payload = {
    "pm1:int": 0,
    "humidity:float": 0,
    "co:int": 0,
    co2: 0,
    ozone: 0,
    no2: 0,
    pm1: 0,
    "pm25:int": 0,
    pm4: 0,
    "virusIndex:int": 0,
    temperature: 0,
    humidity: 0,
    "airPressure:float": 0,
    tvoc: 0,
    device_key: "",
    airPressure: 0,
    pm10: 0,
    "tvoc:int": 0,
    co: 0,
    "co2:int": 0,
    pm25: 0,
    virusIndex: 0,
    "temperature:float": 0,
    "no2:float": 0,
    "pm10:int": 0,
    "pm4:int": 0,
    "ozone:int": 0,
  };
  constructor(model) {
    if (model) {
      Object.assign(this, model);
    }
  }
}

/**
 * 获取仪表盘设备数据
 * Fetches historical chart data for a specific device asset within a given time range and interval.
 *
 * @param {Object} params - The parameters for fetching device data.
 * @param {string} params.assetId - The unique identifier of the device asset.
 * @param {string|number} params.startTime - The start time for the data range (ISO string or timestamp).
 * @param {string|number} params.endTime - The end time for the data range (ISO string or timestamp).
 * @param {string} [params.interval="auto"] - The interval for data aggregation (e.g., "auto", "hour", "day").
 * @returns {Promise<DashboardChartDeviceDataResponse[]>} The Axios promise resolving to the device data.
 */
export async function getDashboardChartDeviceData({
  assetId,
  startTime,
  endTime,
  interval = "auto", //influx支持的单位ms s m h d w
} = {}) {
  const res = await axiosInstance.get(
    `/dashboard/data/devices/${assetId}/history`,
    {
      params: {
        start: startTime,
        end: endTime,
        interval: interval,
      },
    }
  );
  // 适配成 DashboardChartDeviceDataResponse[]
  return (res || []).map((item) => new DashboardChartDeviceDataResponse(item));
}

export async function getDashboardChartDeviceDataV2({
  assetId,
  startTime,
  endTime,
  interval = "auto", //influx支持的单位ms s m h d w mo
} = {}) {
  if (assetId === undefined) return Promise.resolve([]);
  const res = await axiosInstance.get(`/dashboard/data/devices/history`, {
    params: {
      start: startTime,
      end: endTime,
      interval: interval,
      assetId: assetId, // 兼容旧版本
    },
  });
  const list = (res || []).map(
    (item) => new DashboardChartDeviceDataResponse(item)
  );
  return Promise.resolve(list);
  // 适配成 DashboardChartDeviceDataResponse[]
}

/**
 * [default-agent-prompt](../pages/ai-agent/components/default-agent-prompt.js)
 */
export class AgentItemModel {
  agent_id = "";
  functions = [];
  constructor(opt) {
    if (opt) {
      Object.assign(this, opt);
    }
  }
}

/**
 * 获得智能体列表
 */
export async function getAgents() {
  const response = await axiosInstance.get("/agents");
  const list = (response?.agents || []).map((item) => new AgentItemModel(item));
  return {
    list,
  };
}

/**
 * 创建agent
 * @param {AgentItemModel} model - Agent模型实例
 * @returns {Promise<void>}
 */
export function addOrUpdateAgent(model) {
  return axiosInstance.post("/agents", model);
}

/**
 * 删除agent
 * @param {string} id
 * @returns {Promise<void>}
 */
export function deleteAgent(id) {
  return axiosInstance.delete(`/agents/${id}`);
}

/**
 * 管理端获得agent所有属性
 */

class RetrieveAgentAllPropertiesResponse {
  max_conversation_time = "";
  conversation_history_limit = "";
  websocket_id = "";
  id = "";
  name = "";
  base_model = "";
  prompt = "";
  description = "";
  personality = "";
  websocket_url = "";
  function_list = "[]";
  workflow_list = "[]";
  suggested_messages = "[]";
  avatar_url = "";
  constructor(data = {}) {
    Object.assign(this, data);
  }
}

/**
 * 获取agent
 * @param {string} agentId
 * @returns {Promise<RetrieveAgentAllPropertiesResponse>}
 */
export async function getAgentById(agentId) {
  const lang = localStorage.getItem("lang") ?? "en";
  const data = await axiosInstance.get(`/agents/${agentId}`, {
    params: {
      lang,
    },
  });
  return new RetrieveAgentAllPropertiesResponse(data);
}

/**
 * 获取会话状态
 * @param conversationId
 * @param agentId
 * @returns {'status':'Agent is ready'} | {'status': 'Agent is not ready'}
 */
export async function getConversationStatus(conversationId) {
  return await axiosInstance.get(`/conversations/${conversationId}/status`);
}

/**
 * 上传文件到智能体服务器
 * @param {File} file
 * @param {function} [onUploadProgress]
 * @returns {Promise<{success:boolean,url:string}>}
 */
export async function uploadFileToAgentServer(file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  if (typeof onUploadProgress === "function") {
    config.onUploadProgress = onUploadProgress;
  }
  return axiosInstance.post("/agents/upload", formData, config);
}

/**
 * 创建设备指标
 * @param {*} model
 * @returns
 */
export async function createDeviceMetric(model) {
  return axiosInstance.post("/assets/virtual_metric", model);
}

/**
 * 更新设备指标
 * @param {*} model
 * @returns
 */
export async function updateDeviceMetric(model) {
  return axiosInstance.put(`/assets/virtual_metric`, model);
}

/**
 * 新增AI审核记录响应模型
 * @typedef {Object} AiAuditRecord
 * @property {number} id - 审核ID
 * @property {number} eventId - 事件ID
 * @property {string} agentId - 智能体ID
 * @property {string} deviceKey - 设备Key
 * @property {string} type - 审核类型（如 "True"）
 * @property {string} feedback - 审核反馈内容
 * @property {string} userId - 用户ID
 * @property {number} createdAt - 创建时间（时间戳，毫秒）
 * @property {number} updatedAt - 更新时间（时间戳，毫秒）
 * @property {string} createdAtIso - 创建时间（ISO字符串）
 * @property {string} updatedAtIso - 更新时间（ISO字符串）
 * @property {AiAuditEvent} event - 事件详情
 */

/**
 * @typedef {Object} AiAuditEvent
 * @property {number} id - 事件ID
 * @property {string} userId - 用户ID
 * @property {string} name - 事件名称
 * @property {string} type - 事件类型
 * @property {string} event - 事件描述
 * @property {string|null} executionId - 执行ID
 * @property {number} timestamp - 时间戳
 * @property {string} isoTimeString - 事件时间（ISO字符串）
 * @property {number} level - 事件等级
 * @property {number} status - 事件状态
 * @property {string} deviceKey - 设备Key
 * @property {string} assetName - 资产名称
 * @property {Object} agentInfo - 智能体信息（包含 reply、agentId、conversationId 等）
 * @property {AiAuditRecord|null} aiAudit - AI审核信息，可能为null
 */

/**
 * 新增AI审核记录
 * @param {Object} data
 * @param {number} data.eventId
 * @param {string} data.agentId
 * @param {string} data.deviceKey
 * @param {string} data.type
 * @param {string} data.feedback
 * @returns {Promise<{audit: AiAuditRecord}>}
 */
export function createAiAudit(data) {
  return axiosInstance.post("/dashboard/ai-audit", data);
}

/**
 * 更新AI审核记录
 * @param {Object} data - 审核记录数据
 * @param {number} data.eventId - 事件ID
 * @param {string} data.agentId - 智能体ID
 * @param {string} data.deviceKey - 设备Key
 * @param {string} data.type - 审核类型（如 "False"）
 * @param {string} data.feedback - 审核反馈内容
 * @returns {Promise<{audit: AiAuditRecord}>}
 */
export function updateAiAudit(data) {
  return axiosInstance.put("/dashboard/ai-audit", data);
}

/**
 * 获取AI审核记录
 * @param {Object} [params]
 * @returns {Promise<Array<AiAuditListItem>>}
 */
/**
 * @typedef {Object} AiAuditListItem
 * @property {number} id - 审核ID
 * @property {number} eventId - 事件ID
 * @property {string} agentId - 智能体ID（如 "solar-alert-manager"）
 * @property {string} deviceKey - 设备Key
 * @property {string} type - 审核类型（如 "True"）
 * @property {string} feedback - 审核反馈内容
 * @property {string} userId - 用户ID
 * @property {number} createdAt - 创建时间（时间戳，毫秒）
 * @property {string} createdAtIso - 创建时间（ISO字符串）
 * @property {number} updatedAt - 更新时间（时间戳，毫秒）
 * @property {string} updatedAtIso - 更新时间（ISO字符串）
 * @property {AiAuditEvent} event - 事件详情
 */

/**
 * @typedef {Object} AiAuditEvent
 * @property {number} id - 事件ID
 * @property {string} userId - 用户ID
 * @property {string} name - 事件名称
 * @property {string} type - 事件类型
 * @property {string} event - 事件描述
 * @property {string|null} executionId - 执行ID
 * @property {number} timestamp - 时间戳
 * @property {string} isoTimeString - 事件时间（ISO字符串）
 * @property {number} level - 事件等级
 * @property {number} status - 事件状态
 * @property {string} deviceKey - 设备Key
 * @property {string} assetName - 资产名称
 * @property {Object|null} tagInfo - 标签信息
 * @property {Object} agentInfo - 智能体信息（包含 reply、agentId、conversationId 等）
 */
export function getAiAuditList(params) {
  return axiosInstance.get("/dashboard/ai-audit", { params });
}

/**
 * 获取AI审核记录单条详情
 * @param {string} id - 审核记录ID
 * @returns {Promise<AiAuditRecord>}
 */
export function getAiAuditById(id) {
  return axiosInstance.get("/dashboard/ai-audit/detail", {
    params: { id },
  });
}

/**
 * 删除AI审核记录
 * @param {string} id - 审核记录ID
 * @returns {Promise}
 */
export function deleteAiAuditById(id) {
  return axiosInstance.delete("/dashboard/ai-audit", {
    params: { id },
  });
}

/**
 * AgentFunctionSchema
 * @typedef {Object} AgentFunctionSchema
 * @property {string} type
 * @property {Object} function
 * @property {string} function.name
 * @property {string} function.description
 * @property {Object} function.parameters
 * @property {string} function.parameters.type
 * @property {Object} function.parameters.properties
 * @property {string[]} [function.parameters.required]
 */

/**
 * AgentFunctionItem
 * @typedef {Object} AgentFunctionItem
 * @property {string} function_id
 * @property {string} display_name
 * @property {string} function_webhook
 * @property {AgentFunctionSchema} schema
 * @property {string} function_type
 */

/**
 * 新增 Function
 * @param {AgentFunctionItem} model
 * @returns {Promise<void>}
 */
export async function addAgentFunction(model) {
  await axiosInstance.post("/agents/functions", model);
}

/**
 * 查询 Function 列表
 * @returns {Promise<AgentFunctionItem[]>}
 */
export async function getAgentFunctions() {
  const response = await axiosInstance.get("/agents/functions");
  return response;
}

/**
 * 查询单个 Function
 * @param {string} functionId
 * @returns {Promise<AgentFunctionItem>}
 */
export async function getAgentFunction(functionId) {
  const response = await axiosInstance.get(`/agents/functions/${functionId}`);
  return response;
}

/**
 * 更新 Function
 * @param {string} functionId
 * @param {AgentFunctionItem} model
 * @returns {Promise<void>}
 */
export async function updateAgentFunction(functionId, model) {
  await axiosInstance.put(`/agents/functions/${functionId}`, model);
}

/**
 * 删除 Function
 * @param {string} functionId
 * @returns {Promise<void>}
 */
export async function deleteAgentFunction(functionId) {
  await axiosInstance.delete(`/agents/functions/${functionId}`);
}
/**
 * 仪表盘模型相关接口
 *
 * 1. 新增模型
 * @param {Object} model - 模型对象
 * @returns {Promise}
 * 示例 model:
 * {
 *   id: "model1",
 *   name: "测试模型",
 *   desc: "这是一个测试模型",
 *   paramList: [
 *     { name: "interval", type: "Object", desc: "区间参数", value: { low: 15, medium: 20, high: 30 } },
 *     { name: "enabled", type: "Boolean", desc: "是否启用", value: true }
 *   ]
 * }
 */
export function createDashboardModel(model) {
  return axiosInstance.post("/dashboard/model", model);
}

/**
 * 查询所有模型
 * @returns {Promise<Array>}
 */
export function getDashboardModels() {
  // const userId = getUserFromSession()?.id;
  return axiosInstance.get("/dashboard/model", {
    // headers: { "user-id": userId },
  });
}

export function getDashboardModelParam(modelId, paramName) {
  return axiosInstance.get("/dashboard/model/params", {
    params: { id: modelId, paramName },
  });
}

/**
 * 查询单个模型
 * @param {string} modelId
 * @returns {Promise<Object>}
 */
export function getDashboardModelDetail(modelId) {
  return axiosInstance.get("/dashboard/model/detail", {
    params: { id: modelId },
  });
}

/**
 * 更新模型（所有信息，包括参数）
 * @param {Object} model
 * @returns {Promise}
 */
export function updateDashboardModel(model) {
  return axiosInstance.put("/dashboard/model", model);
}

/**
 * 更新指定参数（只更新value）
 * @param {string} modelId
 * @param {string} paramName
 * @param {Object} valueObj - 只包含 value 字段
 * @returns {Promise}
 */
export function updateDashboardModelParam(modelId, paramName, valueObj) {
  return axiosInstance.put("/dashboard/model/param", valueObj, {
    params: { modelId, paramName },
  });
}

/**
 * 删除模型
 * @param {string} modelId
 * @returns {Promise}
 */
export function deleteDashboardModel(modelId) {
  return axiosInstance.delete("/dashboard/model", {
    params: { id: modelId },
  });
}

/**
 * 获取工具调用结果
 * @param conversationId 会话ID
 * @param toolCallId 工具调用ID
 * @returns 工具调用结果
 * post body:
 * ```json
 * {
 *   "result": {
 *     "startTime": "2025-11-01T00:00:00Z",
 *     "endTime": null
 *   }
 * }
 * ```
 */
export async function sendToolCall(params) {
  const { conversationId, toolCallId, body = {} } = params;
  return axiosInstance.post(`/conversations/tools/result`, body, {
    params: {
      conversation_id: conversationId,
      tool_call_id: toolCallId,
    },
  });
}

// WhatsApp Notification API

const MOCK_NOTIFICATION_TOKEN =
  "nJYHN9-kTIuVp86u.2zNSRoPrK7VN4TZ8szWjJwqXUvSykFdlEX88HMtng3dngAWroXsKJjU93HyZ8eEgb26i7rEBxzaWDALKwzrl_wVSwQmAqYeYTBjmW_klh1NjyFcF4J5NMqwikJoIRLYN7TqTe4gKRDCskc8rGyKMRZ9KcoI";
const MOCK_NOTIFICATION_STORE_KEY = "mock-public-notification-feedback";

function shouldUseMockPublicNotification(token) {
  return (
    process.env.NODE_ENV !== "production" && token === MOCK_NOTIFICATION_TOKEN
  );
}

function getMockNotificationState() {
  const defaultState = {
    event: {
      id: 10086,
      name: "Camera Alert: Back Door Motion",
      event:
        "AI detected unusual motion near the back door after business hours. Please review whether this is a true alert.",
      level: 2,
      status: 0,
      assetName: "Back Door Camera",
      deviceKey: "CAM-BACK-DOOR-01",
      escalated: 2,
      isoTimeString: "2026-05-14T02:35:00Z",
      sentAt: "2026-05-14T02:36:20Z",
      aiAudit: null,
    },
    aiAuditList: [],
    snooze: {
      active: false,
      until: "",
      message: "",
    },
  };

  try {
    const savedState = JSON.parse(
      localStorage.getItem(MOCK_NOTIFICATION_STORE_KEY) || "{}"
    );
    return {
      ...defaultState,
      ...savedState,
      event: {
        ...defaultState.event,
        ...(savedState.event || {}),
      },
      snooze: {
        ...defaultState.snooze,
        ...(savedState.snooze || {}),
      },
      aiAuditList: savedState.aiAuditList || defaultState.aiAuditList,
    };
  } catch (error) {
    return defaultState;
  }
}

function setMockNotificationState(nextState) {
  try {
    localStorage.setItem(
      MOCK_NOTIFICATION_STORE_KEY,
      JSON.stringify(nextState)
    );
  } catch (error) {
    console.log("failed to save mock notification state: " + error);
  }
  return nextState;
}

function getMockPublicNotificationEvent() {
  const state = getMockNotificationState();
  return {
    event: {
      ...state.event,
      aiAudit: state.aiAuditList[0] || null,
    },
    aiAuditList: state.aiAuditList,
  };
}

function saveMockPublicNotificationAiAudit(payload = {}) {
  const state = getMockNotificationState();
  const audit = {
    id: payload.id || Date.now(),
    type: payload.type || "",
    feedback: payload.feedback || "",
    createdAt: new Date().toISOString(),
  };
  const aiAuditList = payload.id
    ? state.aiAuditList.map((item) => (item.id === payload.id ? audit : item))
    : [audit, ...state.aiAuditList];
  setMockNotificationState({
    ...state,
    event: {
      ...state.event,
      status: 1,
      aiAudit: audit,
    },
    aiAuditList,
  });
  return { updated: 1, audit };
}

function getMockPublicNotificationSnooze() {
  return getMockNotificationState().snooze;
}

function setMockPublicNotificationSnooze(payload = {}) {
  const state = getMockNotificationState();
  const until =
    payload.mode === "until" && payload.until
      ? payload.until
      : dayjs().endOf("day").toISOString();
  const snooze = {
    active: true,
    until,
    message: "此警報目前已暫停。",
  };
  setMockNotificationState({
    ...state,
    snooze,
  });
  return snooze;
}

function clearMockPublicNotificationSnooze() {
  const state = getMockNotificationState();
  setMockNotificationState({
    ...state,
    snooze: {
      active: false,
      until: "",
      message: "",
    },
  });
  return { message: "警報已恢復。" };
}

/**
 * 获取公开的告警详情（包含 AI 审核记录）
 * @param {string} token - 分享链接中的 token
 * @returns {Promise<{event:Object, aiAuditList:Array}>}
 */
export function getPublicNotificationEvent(token) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(getMockPublicNotificationEvent());
  }
  return axiosInstance.get("/public/dashboard/notification/event", {
    params: { token },
  });
}

/**
 * 更新公开告警的状态
 * @param {string} token - 分享链接中的 token
 * @param {{status:number}} payload - 状态变更参数
 * @returns {Promise<{updated:number}>}
 */
export function updatePublicNotificationEventStatus(token, payload) {
  return axiosInstance.put("/public/dashboard/notification/event", payload, {
    params: { token },
  });
}

/**
 * 创建公开告警的 AI 审核记录
 * @param {string} token - 分享链接中的 token
 * @param {{type:string, feedback:string}} payload - 反馈内容
 * @returns {Promise}
 */
export function createPublicNotificationAiAudit(token, payload) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(saveMockPublicNotificationAiAudit(payload));
  }
  return axiosInstance.post(
    "/public/dashboard/notification/ai-audit",
    payload,
    {
      params: { token },
    }
  );
}

/**
 * 更新公开告警的 AI 审核记录
 * @param {string} token - 分享链接中的 token
 * @param {{id:number, type:string, feedback:string}} payload - 反馈内容
 * @returns {Promise}
 */
export function updatePublicNotificationAiAudit(token, payload) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(saveMockPublicNotificationAiAudit(payload));
  }
  return axiosInstance.put("/public/dashboard/notification/ai-audit", payload, {
    params: { token },
  });
}

/**
 * 查询公开告警当前的 snooze 状态
 * @param {string} token - 分享链接中的 token
 * @returns {Promise<{active:boolean, until?:string, message?:string}>}
 */
export function getPublicNotificationSnooze(token) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(getMockPublicNotificationSnooze());
  }
  return axiosInstance.get("/public/dashboard/notification/snooze", {
    params: { token },
  });
}

/**
 * 设置公开告警的 snooze
 * @param {string} token - 分享链接中的 token
 * @param {{mode:"today"}|{mode:"until", until:string}} payload - snooze 参数
 * @returns {Promise<{active:boolean, until?:string, message?:string}>}
 */
export function setPublicNotificationSnooze(token, payload) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(setMockPublicNotificationSnooze(payload));
  }
  return axiosInstance.post("/public/dashboard/notification/snooze", payload, {
    params: { token },
  });
}

/**
 * 清除公开告警的 snooze
 * @param {string} token - 分享链接中的 token
 * @returns {Promise<{message:string}>}
 */
export function clearPublicNotificationSnooze(token) {
  if (shouldUseMockPublicNotification(token)) {
    return Promise.resolve(clearMockPublicNotificationSnooze());
  }
  return axiosInstance.delete("/public/dashboard/notification/snooze", {
    params: { token },
  });
}

/**
 * Create a notification rule
 * @param {NotificationRule} rule - Rule details
 * @returns {Promise<{success: boolean, id: number}>}
 */
export function createNotificationRule(rule) {
  return axiosInstance.post("/dashboard/notification/rules", rule);
}

/**
 * Update a notification rule
 * @param {number} id - Rule ID
 * @param {NotificationRule} rule - Rule details
 * @returns {Promise<{success: boolean}>}
 */
export function updateNotificationRule(rule) {
  return axiosInstance.put(`/dashboard/notification/rules/${rule.id}`, rule);
}

/**
 * List all notification rules
 * @returns {Promise<Array<NotificationRule>>}
 */
export function listNotificationRules(params = {}) {
  return axiosInstance.get("/dashboard/notification/rules", { params });
}

/**
 * Get a notification rule by ID
 * @param {number} id - Rule ID
 * @returns {Promise<NotificationRule>}
 */
export function getNotificationRule(id) {
  return axiosInstance.get(`/dashboard/notification/rules/${id}`);
}

/**
 * Delete a notification rule
 * @param {number} id - Rule ID
 * @returns {Promise<{success: boolean}>}
 */
export function deleteNotificationRule(id) {
  return axiosInstance.delete(`/dashboard/notification/rules/${id}`);
}

/**
 * Create a notification recipient
 * @param {NotificationRecipient} recipient - Recipient details
 * @returns {Promise<{success: boolean, id: number}>}
 */
export function createNotificationRecipient(recipient) {
  return axiosInstance.post("/dashboard/notification/recipients", recipient);
}

/**
 * Update a notification recipient
 * @param {number} id - Recipient ID
 * @param {NotificationRecipient} recipient - Recipient details
 * @returns {Promise<{success: boolean}>}
 */
export function updateNotificationRecipient(recipient) {
  return axiosInstance.put(
    `/dashboard/notification/recipients/${recipient.id}`,
    recipient
  );
}

/**
 * List all notification recipients
 * @returns {Promise<Array>}
 */
export function listNotificationRecipients(params = {}) {
  return axiosInstance.get("/dashboard/notification/recipients", { params });
}

/**
 * Get a notification recipient by ID
 * @param {number} id - Recipient ID
 * @returns {Promise<Object>}
 */
export function getNotificationRecipient(id) {
  return axiosInstance.get(`/dashboard/notification/recipients/${id}`);
}

/**
 * Delete a notification recipient
 * @param {number} id - Recipient ID
 * @returns {Promise<{success: boolean}>}
 */
export function deleteNotificationRecipient(id) {
  return axiosInstance.delete(`/dashboard/notification/recipients/${id}`);
}

/**
 * 测试通知模板
 * @param {{ruleId?:number, recipientId?:number}} params - 传入 ruleId 或 recipientId
 * @returns {Promise<Object>} 测试结果
 */
export function testNotificationTemplate(params = {}) {
  const query = {};
  if (typeof params.ruleId !== "undefined") {
    query.ruleId = params.ruleId;
  }
  if (typeof params.recipientId !== "undefined") {
    query.recipientId = params.recipientId;
  }
  return axiosInstance.post(
    "/dashboard/notification/test",
    {},
    {
      params: query,
    }
  );
}

/**
 * 获取通知历史记录
 *
 * @param {Object} [params] - 查询参数（可选）
 * @param {number} [params.ruleId] - 通知规则ID
 * @param {number} [params.eventId] - 事件ID
 * @param {number} [params.recipientId] - 接收人ID
 * @param {string} [params.deviceKeys] - 设备Key，逗号分隔
 * @param {string} [params.status] - 通知状态（如 "SENT", "FAILED"）
 * @param {number|string} [params.startTime] - 起始时间（时间戳或ISO字符串）
 * @param {number|string} [params.endTime] - 结束时间（时间戳或ISO字符串）
 * @param {number} [params.page=1] - 页码，默认1
 * @param {number} [params.pageSize=10] - 每页数量，默认10
 * @returns {Promise<{
 *   totalCount: number,
 *   pageSize: number,
 *   totalPage: number,
 *   currPage: number,
 *   list: Array<{
 *     id: number,
 *     userId: number,
 *     eventId: number,
 *     ruleId: number,
 *     recipientId: number,
 *     deviceKeys: string,
 *     message: string,
 *     status: string,
 *     errorMsg: string|null,
 *     providerMsgId: string,
 *     sentAt: number,
 *     createdAt: number
 *   }>
 * }>} 通知历史分页数据
 */
export function getNotificationHistory(params) {
  return axiosInstance.get("/dashboard/notification/history", { params });
}

/**
 * @typedef {Object} NotificationRule
 * @property {number} id - Rule ID
 * @property {number} userId - User ID
 * @property {string} ruleName - Name of the rule
 * @property {string} description - Description of the rule
 * @property {string} deviceKeys - Comma-separated device keys
 * @property {string} eventLevels - , separated event levels ids
 * @property {number} cooldownMin - Cooldown time in minutes
 * @property {string} template - Notification message template
 * @property {string} recipientIds - Comma-separated recipient IDs
 * @property {number} enabled - Whether the rule is enabled (1 for true, 0 for false)
 * @property {number} createdAt - Creation timestamp (ms)
 * @property {number} updatedAt - Update timestamp (ms)
 */

/**
 * @typedef {Object} NotificationRuleResponse
 * @property {boolean} success - Whether the operation was successful
 * @property {number} [id] - ID of the created or updated rule (if applicable)
 */

/**
 * @typedef {Object} NotificationRecipient
 * @property {number} id - Recipient ID
 * @property {number} userId - User ID
 * @property {string} name - Name of the recipient
 * @property {string} phone - Phone number of the recipient
 * @property {number} createdAt - Creation timestamp (ms)
 * @property {number} updatedAt - Update timestamp (ms)
 */

/**
 * @typedef {Object} NotificationRecipientResponse
 * @property {boolean} success - Whether the operation was successful
 * @property {number} [id] - ID of the created or updated recipient (if applicable)
 */

/**
 * @typedef {Object} NotificationHistoryItem
 * @property {number} id - ID of the notification history item
 * @property {number} userId - ID of the user
 * @property {number} eventId - ID of the event
 * @property {number} ruleId - ID of the rule
 * @property {number} recipientId - ID of the recipient
 * @property {string} deviceKeys - Comma-separated device keys
 * @property {string} message - Notification message
 * @property {string} status - Status of the notification (e.g., SENT, FAILED)
 * @property {string|null} errorMsg - Error message, if any
 * @property {string} providerMsgId - Provider message ID
 * @property {number} sentAt - Timestamp when the notification was sent
 * @property {number} createdAt - Timestamp when the notification was created
 */

/**
 * @typedef {Object} NotificationHistoryResponse
 * @property {number} totalCount - Total number of history items
 * @property {number} pageSize - Number of items per page
 * @property {number} totalPage - Total number of pages
 * @property {number} currPage - Current page number
 * @property {NotificationHistoryItem[]} list - List of notification history items
 */

/**
 * 获取通知历史汇总
 *
 * @param {Object} [params] - 查询参数（可选）
 * @param {number} [params.ruleId] - 通知规则ID
 * @param {number} [params.eventId] - 事件ID
 * @param {string} [params.deviceKeys] - 设备Key，逗号分隔
 * @param {string} [params.status] - 通知状态（如 "SENT", "FAILED")
 * @param {string} [params.notifyType] - 通知类型
 * @param {number|string} [params.startTime] - 起始时间
 * @param {number|string} [params.endTime] - 结束时间
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.pageSize=10] - 每页数量
 * @returns {Promise<{
 *   totalCount: number,
 *   pageSize: number,
 *   totalPage: number,
 *   currPage: number,
 *   list: Array<{
 *     eventId: number,
 *     ruleId: number,
 *     ruleName: string,
 *     deviceKeys: string,
 *     assetName: string,
 *     status: string,
 *     escalated: number
 *   }>
 * }>}
 */
export function getNotificationHistorySummary(params = {}) {
  return axiosInstance.get("/dashboard/notification/history/summary", {
    params,
  });
}

// ESL Cloud API proxy endpoints (docs/Esl Cloud API(中文)(3).pdf)
// Requests are forwarded through https://dev-axiosInstance.cereb.ai/v1/fission/e-tag/fission/e-tag

/**
 * @typedef {Object} EslSignedPayload
 * @property {string} store_code - Store identifier required by ESL Cloud.
 * @property {"0"|"1"} [is_base64="0"] - Whether the payload values are base64 encoded (doc default 0).
 * @property {string} sign - Vendor issued token (doc default 80805d794841f1b4).
 */

/**
 * @typedef {Object} EslProductModel
 * @property {string} [pi] - Internal SKU code (商品内部编码).
 * @property {string} pc - Public product code (商品编码).
 * @property {string} pn - Product name (商品名称).
 * @property {string} [ps] - Specification text (商品规格).
 * @property {string} [pg] - Grade/category label (商品等级).
 * @property {string} [pu] - Unit text such as "kg" (商品单位).
 * @property {string|number} pp - Primary price (商品价格).
 * @property {string|number} [vp] - VIP/member price (商品VIP价格).
 * @property {string|number} [pop] - Original/strike-through price (商品原价).
 * @property {string} [po] - Product origin (商品产地).
 * @property {string} [pm] - Manufacturer text (商品制造商).
 * @property {number|null} [promotion] - Promotion flag defined by ESL Cloud (促销场景).
 * @property {string} [pim] - Image URL (商品圖片地址).
 * @property {string} [pqr] - QR code URL (商品二維碼地址).
 * @property {string} [f1] - Custom field 1 (自定义字段1).
 * @property {string} [f2] - Custom field 2.
 * @property {string} [f3] - Custom field 3.
 * @property {string} [f4] - Custom field 4.
 * @property {string} [f5] - Custom field 5.
 * @property {string} [f6] - Custom field 6.
 * @property {string} [f7] - Custom field 7.
 * @property {string} [f8] - Custom field 8.
 * @property {string} [f9] - Custom field 9.
 * @property {string} [f10] - Custom field 10.
 * @property {string} [f11] - Custom field 11.
 * @property {string} [f12] - Custom field 12.
 * @property {string} [f13] - Custom field 13.
 * @property {string} [f14] - Custom field 14.
 * @property {string} [f15] - Custom field 15.
 * @property {string} [f16] - Custom field 16.
 * @property {Object.<string, string>} [extend] - Extended JSON such as { "e001": "v11" } (拓展字段JSON).
 */
export class EslProductModel {
  id = null;
  pi = null;
  pc = null;
  pn = null;
  ps = null;
  pg = null;
  pu = null;
  pp = null;
  vp = null;
  pop = null;
  po = null;
  pm = null;
  promotion = null;
  pim = null;
  pqr = null;
  desc = null;
  kc = null;
  kc_threshold = null;
  enabled = null;
  video = null;
  videoId = null;
  imagesId = null;
  product_from = null;
  users_username = null;
  store_code = null;
  product_sales_price = null;
  product_vip_price = null;
  product_origin_price = null;
  product_image_id = null;
  esls_api = null;
  extend = null;
  // Support f1-f50
  f1 = null;
  f2 = null;
  f3 = null;
  f4 = null;
  f5 = null;
  f6 = null;
  f7 = null;
  f8 = null;
  f9 = null;
  f10 = null;
  f11 = null;
  f12 = null;
  f13 = null;
  f14 = null;
  f15 = null;
  f16 = null;
  f17 = null;
  f18 = null;
  f19 = null;
  f20 = null;
  f21 = null;
  f22 = null;
  f23 = null;
  f24 = null;
  f25 = null;
  f26 = null;
  f27 = null;
  f28 = null;
  f29 = null;
  f30 = null;
  f31 = null;
  f32 = null;
  f33 = null;
  f34 = null;
  f35 = null;
  f36 = null;
  f37 = null;
  f38 = null;
  f39 = null;
  f40 = null;
  f41 = null;
  f42 = null;
  f43 = null;
  f44 = null;
  f45 = null;
  f46 = null;
  f47 = null;
  f48 = null;
  f49 = null;
  f50 = null;
  constructor(opt = {}) {
    // Map API fields to model fields, prefer null for missing values
    this.id = opt.id ?? null;
    this.pc = opt.product_code ?? opt.pc ?? null;
    this.pi = opt.product_inner ?? opt.pi ?? null;
    this.pn = opt.product_name ?? opt.pn ?? null;
    this.ps = opt.product_spec ?? opt.ps ?? null;
    this.pg = opt.product_grade ?? opt.pg ?? null;
    this.pp = opt.product_price ?? opt.pp ?? null;
    this.pu = opt.product_unit ?? opt.pu ?? null;
    this.pop = opt.product_origin_price ?? opt.pop ?? null;
    this.pm = opt.product_mfrs ?? opt.pm ?? null;
    this.po = opt.product_origin ?? opt.po ?? null;
    this.desc = opt.product_desc ?? opt.desc ?? null;
    this.pim = opt.product_image ?? opt.pim ?? null;
    this.pqr = opt.product_qrcode ?? opt.pqr ?? null;
    this.enabled = opt.enabled ?? null;
    this.promotion = opt.promotion ?? null;
    this.created_at = opt.created_at ?? null;
    this.updated_at = opt.updated_at ?? null;
    this.kc = opt.product_storage ?? opt.kc ?? null;
    this.kc_threshold = opt.product_storage_threshold ?? null;
    this.product_vip_price = opt.product_vip_price ?? null;
    this.product_sales_price = opt.product_sales_price ?? null;
    this.product_from = opt.product_from ?? null;
    this.users_username = opt.users_username ?? null;
    this.store_code = opt.store_code ?? null;
    this.video = opt.video ?? null;
    this.videoId = opt.video_id ?? opt.videoId ?? null;
    this.imagesId = opt.product_image_id ?? opt.imagesId ?? null;
    this.esls_api = opt.esls_api ?? null;
    // Map fieldN to fN
    for (let i = 1; i <= 50; i++) {
      this[`f${i}`] = opt[`field${i}`] ?? opt[`f${i}`] ?? null;
    }
    // Map extend (array or object)
    if (Array.isArray(opt.extend)) {
      this.extend = {};
      opt.extend.forEach((item, idx) => {
        this.extend[`e${String(idx + 1).padStart(3, "0")}`] = item;
      });
    } else if (typeof opt.extend === "object" && opt.extend !== null) {
      this.extend = opt.extend;
    } else {
      this.extend = null;
    }
    // Assign any remaining fields
    Object.assign(this, opt);
  }
}

/**
 * @typedef {EslSignedPayload & EslProductModel} EslProductRequest
 * @property {string} store_code - Store scoped identifier.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {EslSignedPayload & {f1: EslProductModel[]}} EslProductBatchRequest
 * @property {EslProductFields[]} f1 - Array of product objects (商品数组) for batch create/update.
 */

/**
 * @typedef {EslSignedPayload & {f1: string[]}} EslDeleteProductsRequest
 * @property {string[]} f1 - Product codes to delete.
 */

/**
 * @typedef {Object} EslProductQueryParams
 * @property {string} store_code - Store identifier.
 * @property {number} [f1] - Page index (查询页数).
 * @property {number} [f2] - Page size (单页查询数量).
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {EslSignedPayload & {
 *   f1: string,
 *   f2: string,
 *   f3?: string[],
 *   f4?: string[],
 *   f5?: string,
 *   f6?: string,
 *   f7?: Array<{pc: string, pp: string|number}>
 * }} EslPriceAdjustOrderRequest
 * @property {string} f1 - Adjustment order number (调价单号).
 * @property {string} f2 - Adjustment name (调价单名称).
 * @property {string[]} [f3] - Store codes list to trigger (触发门店数组).
 * @property {string[]} [f4] - Trigger weekdays e.g. ["1","3"] (触发周期).
 * @property {string} [f5] - Start time HH:mm.
 * @property {string} [f6] - End time HH:mm.
 * @property {Array<{pc: string, pp: string|number}>} [f7] - Product price pairs included in the order.
 */

/**
 * @typedef {EslSignedPayload & {f1: string}} EslPriceAdjustRef
 * @property {string} f1 - Adjustment order number.
 */

/**
 * @typedef {EslSignedPayload & {f1: string, f2: string, f3?: string}} EslBindRequest
 * @property {string} f1 - ESL tag code (价签编码).
 * @property {string} f2 - Product code to bind.
 * @property {string} [f3="0"] - Template ID (模板ID "0"=默认).
 */

/**
 * @typedef {Object} EslBindItem
 * @property {string} esl_code - ESL tag code.
 * @property {string} product_code - Product code to display.
 * @property {number|string} [esltemplate_id=0] - Template ID for the tag.
 */

/**
 * @typedef {EslSignedPayload & {f1: EslBindItem[]}} EslBindMultipleRequest
 * @property {EslBindItem[]} f1 - Bindings to queue in bulk.
 */

/**
 * @typedef {EslSignedPayload & {f1: string|String[]}} EslSearchOrSyncRequest
 * @property {string|string[]} f1 - Single code or array of ESL codes to flash/sync.
 */

/**
 * @typedef {Object} EslDirectItem
 * @property {string} esl_code - Target ESL code.
 * @property {number|string} template_id - Template to render.
 * @property {EslProductModel} product - Inline product payload for the template.
 * @property {Object} [led] - Optional LED/blink instructions (doc: 闪灯数据).
 */

/**
 * @typedef {EslSignedPayload & {f1: EslDirectItem[]}} EslDirectRequest
 * @property {EslDirectItem[]} f1 - Batch of direct refresh instructions.
 */

/**
 * @typedef {Object} EslTagQueryParams
 * @property {string} store_code - Store identifier.
 * @property {number} [f1] - Page index.
 * @property {number} [f2] - Page size.
 * @property {string[]} [f3] - Specific ESL codes when querying status.
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {Object} PadBindRequest
 * @property {string} store_code - Store identifier.
 * @property {string} pad_code - Pad device MAC/code.
 * @property {string} product_code - Comma separated product codes.
 * @property {string|number} [padtemplate_id="0"] - Pad template id.
 * @property {"A"|"B"} [face="A"] - Face identifier for dual side pads.
 * @property {string} [device_area] - Optional device area label.
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {Object} PadBindMultipleItem
 * @property {string} pad_code - Pad device code.
 * @property {string} product_code - Comma separated product codes bound to the pad.
 * @property {string|number} [padtemplate_id="0"] - Template id for the pad face.
 */

/**
 * @typedef {EslSignedPayload & {f1: PadBindMultipleItem[]}} PadBindMultipleRequest
 * @property {PadBindMultipleItem[]} f1 - Batch pad bindings mirroring the single bind fields.
 */

/**
 * @typedef {Object} PadQueryParams
 * @property {string} store_code - Store identifier.
 * @property {number} [f1] - Page index.
 * @property {number} [f2] - Page size.
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {EslSignedPayload & {f1?: string, f2?: string}} EslStoreRequest
 * @property {string} store_code - Store identifier to create/update.
 * @property {string} f1 - Store name.
 * @property {string} [f2] - Store address.
 */

/**
 * @typedef {Object} TemplateQueryParams
 * @property {string} store_code - Store identifier.
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {Object} NfcQueryParams
 * @property {string} store_code - Store identifier.
 * @property {number} [f1] - Page index.
 * @property {number} [f2] - Page size.
 * @property {"0"|"1"} [is_base64="0"] - Encoding flag.
 * @property {string} sign - ESL token.
 */

/**
 * @typedef {Object} NfcDirectItem
 * @property {string} nfc_code - NFC tag code.
 * @property {number|string} template_id - Template ID for the NFC display.
 * @property {EslProductModel & {extend?: Object.<string, string>}} product - Product payload used on the NFC card.
 */

/**
 * @typedef {EslSignedPayload & {f1: NfcDirectItem[]}} NfcDirectRequest
 * @property {NfcDirectItem[]} f1 - Batch of NFC bindings.
 */

/**
 * @typedef {EslSignedPayload & {
 *   code: string|number,
 *   name: string,
 *   [company]: string,
 *   mobile: string,
 *   [field1]: string,
 *   [field2]: string,
 *   [field3]: string,
 *   [field4]: string,
 *   [field5]: string,
 *   [field6]: string,
 *   [field7]: string,
 *   [field8]: string,
 *   [field9]: string,
 *   [field10]: string
 * }} OfficeVisitorRequest
 * @property {string|number} code - Visitor identifier.
 * @property {string} name - Visitor name.
 * @property {string} mobile - Phone number.
 */

/**
 * @typedef {EslSignedPayload & {
 *   code: string|number,
 *   name: string,
 *   mobile: string,
 *   [company]: string,
 *   [job]: string,
 *   [field1]: string,
 *   [field2]: string,
 *   [field3]: string,
 *   [field4]: string,
 *   [field5]: string,
 *   [field6]: string,
 *   [field7]: string,
 *   [type]: number
 * }} OfficeUserRequest
 * @property {string|number} code - Employee identifier.
 * @property {string} name - Employee name.
 * @property {string} mobile - Phone number.
 * @property {number} [type] - Team/group code defined by ESL Cloud.
 */

const ESL_PROXY_PREFIX = "/fission/e-tag";

function buildEslUrl(pathSuffix) {
  return `${ESL_PROXY_PREFIX}${pathSuffix}`;
}

function normalizeEslPayload(firstArg, secondArg) {
  const isLegacyClientId =
    typeof firstArg === "string" || typeof firstArg === "number";
  if (isLegacyClientId) {
    return secondArg ?? {};
  }
  return firstArg ?? {};
}

function normalizeEslParams(firstArg, secondArg) {
  const isLegacyClientId =
    typeof firstArg === "string" || typeof firstArg === "number";
  if (isLegacyClientId) {
    return secondArg ?? {};
  }
  return firstArg ?? {};
}

/**
 * @param {EslProductModel} payload
 */
export function createEslProduct(payload) {
  return axiosInstance.post(buildEslUrl("/product/create"), payload);
}

export function bulkCreateEslProducts(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/product/create_multiple"), body);
}

/**
 * 批量删除产品
 * @param {f1:Array<string|number>} payload
 */
export function bulkDeleteEslProducts(payload) {
  return axiosInstance.post(buildEslUrl("/product/del_multiple"), payload);
}

export function getEslProductCount(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/product/query_count"), {
    params: query,
  });
}

/**
 * 查询 ESL 商品列表。
 * @param {EslProductQueryParams} [params] - 查询参数（门店、分页、签名等）。
 * @param {EslProductQueryParams} [deprecatedParams] - 兼容旧 clientId 签名方式。
 * @returns {Promise<Array<{
 *     "id": 936466,
 *     "product_code": "101",
 *     "product_name": "test1",
 *     "product_price": "12.70",
 *     "product_vip_price": "0.00",
 *     "promotion": 1,
 *     "product_storage": 0,
 *     "product_storage_threshold": 10,
 *     "product_desc": "备注",
 *     "product_image": null,
 *     "created_at": "2023-11-07 14:20:40",
 *     "updated_at": "2023-11-07 14:20:40"
 *   }>>} ESL 商品数组（字段与 ESL Cloud 响应一致）。
 */
export function getEslProducts(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/product/query"), {
    params: query,
  });
}

export function createEslPriceAdjustment(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/productadjust/create_order"), body);
}

export function deleteEslPriceAdjustment(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/productadjust/del_order"), body);
}

export function triggerEslPriceAdjustment(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/productadjust/adjust_task"), body);
}

/**
 * @param {Object} payload
 * @param {string} payload.f1 - 价签编码
 * @param {string} payload.f2 - 商品编码
 * @param {string} payload.f3 - 模板ID "0"=默认
 */
export function bindEslTag(payload) {
  return axiosInstance.post(buildEslUrl("/esl/bind"), payload);
}

export function bulkBindEslTags(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/esl/bind_multiple"), body);
}

export function unbindEslTag(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/esl/unbind"), body);
}

export function searchEslTags(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/esl/search"), body);
}

export function syncEslTags(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/esl/sync"), body);
}

export function directUpdateEslTags(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/esl/direct"), body);
}

/**
 * 触发价签任务队列
 */
export function triggerEslTasks() {
  return axiosInstance.post(buildEslUrl("/esl/bind_task"));
}

/**
 * 查询 ESL 价签列表。
 *
 * @param {EslTagQueryParams} [params] - 查询参数（页码、页大小等）。
 * @returns {Promise<Array<{
 *     "esl_code": "d450069a",
 *      "esl_version": "2001/2306/0101",
 *      "action": 0,
 *      "online": 1,
 *      "adv_group": 32,
 *      "error_code": 0,
 *      "esltemplate_id": null,
 *      "master_rssi": -63,
 *      "esl_battery": 3020,
 *      "product_code": "4893668850461",
 *      "created_at": "2023-10-09 15:00:48",
 *      "updated_at": "2023-11-08 17:08:37",
 *      "ap_code": "40:d6:3c:74:34:d3",
 *      "esltype_code": "ESL-29R",
 *      "refreshed_at": "2023-10-30 21:32:37",
 *      "retrieved_at": "2023-11-08 17:08:37"
 *    }>>} ESL 价签数组。
 *
 */
export function getEslTags(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/esl/query"), {
    params: query,
  });
}

/**
 * 查询单条商品详情（通过商品编码 pc）
 * @param {Object} params - 查询参数，需包含商品编码 pc
 * @param {string|number} params.pc - 商品编码
 * @returns {Promise<Object>} 商品详情对象
 */
export function getEslProductDetailByCode(code) {
  return axiosInstance.get(buildEslUrl("/product/query/detail"), {
    params: { pc: code },
  });
}

export function getEslTagCount(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/esl/query_count"), {
    params: query,
  });
}

/**
 * @param {Object} payload
 * @param {number} payload.f1 - 查询⻚数
 * @param {number} payload.f2 - 单⻚查询数量
 * @param {string[]} payload.f3 - 价签编号数组
 *
 * @returns {Array<{
 * "esl_code": "d4500584",
 * "esl_version": "2001/2306/0101",
 * "action": 0,
 * "online": 1,
 * "adv_group": 2048,
 * "error_code": 0,
 * "esltemplate_id": 0,
 * "master_rssi": -49,
 * "esl_battery": 3077,
 * "product_code": "101",
 * "created_at": "2023-10-09 14:58:13",
 * "updated_at": "2023-11-08 17:10:04",
 * "ap_code": "40:d6:3c:69:49:7d",
 * "esltype_code": "ESL-29R",
 * "refreshed_at": "2023-11-08 16:34:31",
 * "retrieved_at": "2023-11-08 17:10:04"
 * }>}
 */
export function getEslTagStatus(payload = {}) {
  return axiosInstance.post(buildEslUrl("/esl/query_status"), payload);
}

export function bindPadDisplay(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/pad/bind"), body);
}

export function bulkBindPadDisplays(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/pad/bind_multiple"), body);
}

export function unbindPadDisplay(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/pad/unbind"), body);
}

export function getPadDisplays(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/pad/query"), {
    params: query,
  });
}

export function createEslStore(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/store/create"), body);
}

/**
 * 查询 ESL 模板列表。
 *
 * @example <caption>请求体</caption>
 * ```json
 * {
 *   "store_code": "001",
 *   "is_base64": "0",
 *   "sign": "80805d794841f1b4"
 * }
 *
 * @param {TemplateQueryParams} [params] - 查询参数（门店、签名等）。
 * @param {TemplateQueryParams} [deprecatedParams] - 兼容模式，传入旧的 clientId 时使用。
 * @returns {Promise<Array<{id:number, esltype_code:string, esltemplate_name:string, esltemplate_default:0|1}>>}
 */
export function getEslTemplates(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/template/query"), {
    params: query,
  });
}

export function getNfcTags(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/nfc/query"), {
    params: query,
  });
}

export function getNfcTagCount(params = {}, deprecatedParams) {
  const query = normalizeEslParams(params, deprecatedParams);
  return axiosInstance.get(buildEslUrl("/nfc/query_count"), {
    params: query,
  });
}

export function directBindNfcTags(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/nfc/direct"), body);
}

export function createOfVisitor(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/of/create_visitor"), body);
}

export function deleteOfVisitor(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/of/del_visitor"), body);
}

export function createOfUser(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/of/create_user"), body);
}

export function deleteOfUser(payload, deprecatedPayload) {
  const body = normalizeEslPayload(payload, deprecatedPayload);
  return axiosInstance.post(buildEslUrl("/of/del_user"), body);
}

/**
 * 查询单条商品详情
 * @param {Object} params - 查询参数，需包含商品编码 pc
 * @param {string|number} params.esl_code - 商品编码
 * @returns {Promise<Object>} 商品详情对象
 */
export function getEslProductDetail(params = {}) {
  return axiosInstance.get(buildEslUrl("/product/query/detail"), { params });
}

// ========== Price Task (定时价格任务) API ==========
/**
 * 价格任务模型
 */
export class PriceTaskItemModel {
  product_code = "";
  start_action = {
    product_price: 0,
    product_vip_price: 0,
    product_origin_price: 0,
    template_id: "",
  };
  end_action = {
    product_price: 0,
    product_vip_price: 0,
    product_origin_price: 0,
    template_id: "",
  };
  /**
   * @param {Object} [opts]
   * @param {string} [opts.product_code]
   * @param {Object} [opts.start_action]
   * @param {Object} [opts.end_action]
   */
  constructor(opts = {}) {
    this.product_code = opts.product_code ?? "";
    this.start_action = opts.start_action ?? {
      product_price: 0,
      product_vip_price: 0,
      product_origin_price: 0,
      template_id: "",
    };
    this.end_action = opts.end_action ?? {
      product_price: 0,
      product_vip_price: 0,
      product_origin_price: 0,
      template_id: "",
    };
  }
}

export class PriceTaskModel {
  /**
   * @param {Object} [opts]
   * @param {string} [opts.id]
   * @param {string} [opts.name]
   * @param {string} [opts.pc]
   * @param {Array<string>} [opts.esl_code]
   * @param {string} [opts.start_time]
   * @param {string} [opts.end_time]
   * @param {'pending'|'active'|'completed'} [opts.status]
   * @param {Array<Object>} [opts.items]
   * @param {boolean} [opts.start_applied]
   * @param {boolean} [opts.end_applied]
   */
  constructor(opts = {}) {
    // 设置分钟和秒钟为0，方便用户输入
    const now = dayjs()
      .minute(0)
      .second(0)
      .millisecond(0)
      .format("YYYY-MM-DDTHH:mm:ssZ");
    this.id = opts.id; //create new is undefined
    this.name = opts.name ?? "";
    this.start_time = opts.start_time ?? now;
    this.end_time =
      opts.end_time ?? dayjs(now).add(2, "hour").format("YYYY-MM-DDTHH:mm:ssZ");
    this.status = opts.status ?? "pending";
    this.items = Array.isArray(opts.items) ? opts.items : [];
    this.start_applied = opts.start_applied ?? false;
    this.end_applied = opts.end_applied ?? false;
    this.start_action = opts.start_action ?? {
      product_price: 0,
      product_vip_price: 0,
      product_origin_price: 0,
    };

    this.end_action = opts.end_action ?? {
      product_price: 0,
      product_vip_price: 0,
      product_origin_price: 0,
    };
  }
}
/**
 * 创建价格任务
 * @param {Object} data - 任务数据，见文档
 * @returns {Promise<{
 *   id: string,
 *   name: string,
 *   start_time: string,
 *   end_time: string|null,
 *   status: 'pending'|'active'|'completed',
 *   items: Array<{
 *     "pc": "101",
 *     "esl_code": ["d4500584","d4500587"],
 *     "start_action": {"pp": 12.7, "vp": 9.9, "pop": 15.0, "template_id": "11"},
 *     "end_action": {"pp": 12.7, "vp": 12.7, "pop": 15.0, "template_id": "0"}
 *   }>
 *   start_applied: boolean,
 *   end_applied: boolean,
 *   created_at: string,
 *   updated_at: string
 * }>} 创建后的任务对象
 */
export function createPriceTask(data = new PriceTaskModel()) {
  return axiosInstance.post(buildEslUrl("/price-task"), data);
}

/**
 * PriceTask 查询参数类
 * 可用于 listPriceTasks 查询参数
 */
export class PriceTaskQuery {
  /**
   * @param {Object} [opts]
   * @param {string} [opts.status] - 任务状态 pending/active/completed
   * @param {string} [opts.name] - 任务名称模糊匹配
   * @param {string} [opts.pc] - 商品编码
   * @param {string} [opts.start_from] - RFC3339 起始时间
   * @param {string} [opts.start_to] - RFC3339 截止时间
   * @param {string} [opts.end_from] - RFC3339 起始时间
   * @param {string} [opts.end_to] - RFC3339 截止时间
   */
  constructor(opts = {}) {
    this.status = opts.status;
    this.name = opts.name;
    this.pc = opts.pc;
    this.start_from = opts.start_from;
    this.start_to = opts.start_to;
    this.end_from = opts.end_from;
    this.end_to = opts.end_to;
  }
}
/**
 * 查询价格任务列表
 * @param {PriceTaskQuery|Object} [params] - 查询参数，可用 PriceTaskQuery 实例
 * @returns {Promise<{items: Array<{
 *   id: string,
 *   name: string,
 *   start_time: string,
 *   end_time: string|null,
 *   product_price: number,
 *   status: 'pending'|'active'|'completed',
 *   items: Array<Object>,
 *   start_applied: boolean,
 *   end_applied: boolean,
 *   created_at: string,
 *   updated_at: string
 * }>}>} 任务列表对象
 */
export function listPriceTasks(params = {}) {
  return axiosInstance.get(buildEslUrl("/price-task"), { params });
}

/**
 * 更新价格任务
 * @param {Object} data - 任务数据，需包含 id 字段
 * @returns {Promise<{
 *   id: string,
 *   name: string,
 *   start_time: string,
 *   end_time: string|null,
 *   status: 'pending'|'active'|'completed',
 *   items: Array<Object>,
 *   start_applied: boolean,
 *   end_applied: boolean,
 *   created_at: string,
 *   updated_at: string
 * }>} 更新后的任务对象
 */
export function updatePriceTask(data = new PriceTaskModel()) {
  return axiosInstance.put(buildEslUrl("/price-task"), data);
}

/**
 * 批量删除价格任务
 * @param {Array<string>} ids - 任务 id 数组
 * @returns {Promise<{deleted: Array<string>}>} 删除结果
 */
export function deletePriceTasks(ids) {
  return axiosInstance.delete(buildEslUrl("/price-task"), { data: { ids } });
}

/**
 * 手动触发价格任务定时器（cron runner）
 * @returns {Promise<{
 *   total: number,
 *   start_applied: number,
 *   end_applied: number,
 *   errors: Array
 * }>} 运行结果
 */
export function runPriceTaskCron() {
  return axiosInstance.post(buildEslUrl("/price-task/run"));
}

/**
 * 下载文件
 * @param filename 文件名
 * @returns
 */
export async function downloadFile(url) {
  let filename = url.split("/").pop();
  const response = await axiosInstance.get(url, {
    responseType: "blob",
    params: { file: filename },
  });
  const blob = response;
  return URL.createObjectURL(blob);
}

// ================= 新版通知中心 API =================
// 参考 Postman collection: docs/api-notification.postman_collection.json

// 通知中心命名空间
export class NotificationNamespace {
  constructor({ namespace_id, name, enabled, remark } = {}) {
    this.namespace_id = namespace_id;
    this.name = name;
    this.enabled = enabled;
    this.remark = remark;
  }
}

/**
 * @param {NotificationNamespace} data
 * @returns {Promise<any>}
 */
export function createNotificationNamespace(data) {
  return axiosInstance.post("/notification/namespaces", data);
}

/**
 * @param {string} namespace_id
 * @returns {Promise<any>}
 */
export function getNotificationNamespace(namespace_id) {
  return axiosInstance.get("/notification/namespaces", {
    params: { namespace_id },
  });
}

/**
 * @param {{cursor?: number, page_size?: number}} params
 * @returns {Promise<any>}
 */
export function listNotificationNamespaces(
  params = { cursor: 0, page_size: 20 }
) {
  return axiosInstance.get("/notification/namespaces", { params });
}

/**
 * @param {NotificationNamespace} data
 * @returns {Promise<any>}
 */
export function updateNotificationNamespace(data) {
  return axiosInstance.put("/notification/namespaces", data);
}

/**
 * @param {string} namespace_id
 * @returns {Promise<any>}
 */
export function deleteNotificationNamespace(namespace_id) {
  return axiosInstance.delete("/notification/namespaces", {
    params: { namespace_id },
  });
}

// 通知中心接收人
export class NotificationRecipient {
  constructor({ recipient_id, namespace_id, name, channels, created_at } = {}) {
    this.recipient_id = recipient_id;
    this.namespace_id = namespace_id;
    this.name = name;
    this.channels = channels || [];
    this.created_at = created_at;
  }
}

/**
 * @param {Partial<NotificationRecipient>} data
 * @returns {Promise<any>}
 */
export function createNotificationRecipientV2(data) {
  return axiosInstance.post("/notification/recipients", {
    ...data,
    namespace_id: NAEMESPACE_ID,
  });
}

/**
 * @param {string} recipient_id
 * @returns {Promise<any>}
 */
export function getNotificationRecipientV2(recipient_id) {
  return axiosInstance.get("/notification/recipients", {
    params: { recipient_id },
  });
}

/**
 * @param {{cursor?: number, page_size?: number}} params
 * @returns {Promise<any>}
 */
export function listNotificationRecipientsV2(
  params = { cursor: 0, page_size: 20 }
) {
  return axiosInstance.get("/notification/recipients", {
    params,
  });
}

/**
 * @param {Partial<NotificationRecipient>} data
 * @returns {Promise<any>}
 */
export function updateNotificationRecipientV2(data) {
  return axiosInstance.put("/notification/recipients", {
    ...data,
    namespace_id: NAEMESPACE_ID,
  });
}

/**
 * @param {string} recipient_id
 * @returns {Promise<any>}
 */
export function deleteNotificationRecipientV2(recipient_id) {
  return axiosInstance.delete("/notification/recipients", {
    params: { recipient_id },
  });
}

// 通知中心 Webhook
export class NotificationWebhook {
  constructor({
    name,
    url,
    method,
    headers,
    query,
    body_mode,
    body_template,
    success_criteria,
  } = {}) {
    this.name = name;
    this.url = url;
    this.method = method;
    this.headers = headers;
    this.query = query;
    this.body_mode = body_mode;
    this.body_template = body_template;
    this.success_criteria = success_criteria;
  }
}

/**
 * @param {NotificationWebhook} data
 * @returns {Promise<any>}
 */
export function createNotificationWebhook(data) {
  return axiosInstance.post("/notification/webhooks", data);
}

/**
 * @param {string} webhook_id
 * @returns {Promise<any>}
 */
export function getNotificationWebhook(webhook_id) {
  return axiosInstance.get("/notification/webhooks", {
    params: { webhook_id },
    headers: { "X-Namespace-Id": NAEMESPACE_ID },
  });
}

/**
 * @param {{cursor?: number, page_size?: number}} params
 * @returns {Promise<any>}
 */
export function listNotificationWebhooks(
  params = { cursor: 0, page_size: 20 }
) {
  return axiosInstance.get("/notification/webhooks", {
    params,
  });
}

/**
 * @param {any} data
 * @returns {Promise<any>}
 */
export function updateNotificationWebhook(data) {
  return axiosInstance.put("/notification/webhooks", data);
}

/**
 * @param {string} webhook_id
 * @returns {Promise<any>}
 */
export function deleteNotificationWebhook(webhook_id) {
  return axiosInstance.delete("/notification/webhooks", {
    params: { webhook_id },
  });
}

// 通知中心规则
export class NotificationRule {
  constructor({
    rule_name,
    priority,
    params_match,
    channel,
    template,
    cooldown_min,
    retry_max_attempts,
    recipients,
    escalation_steps,
    enabled,
  } = {}) {
    this.rule_name = rule_name;
    this.priority = priority;
    this.params_match = params_match;
    this.channel = channel;
    this.template = template;
    this.cooldown_min = cooldown_min;
    this.retry_max_attempts = retry_max_attempts;
    this.recipients = recipients || [];
    this.escalation_steps = escalation_steps || [];
    this.enabled = enabled;
  }
}

export class NotificationRuleListItem {
  constructor({
    rule_id,
    namespace_id,
    rule_name,
    priority,
    params_match,
    channel,
    template,
    cooldown_min,
    retry_max_attempts,
    recipients,
    recipient_channels,
    escalation_steps,
    enabled,
    created_at,
  } = {}) {
    this.rule_id = rule_id;
    this.namespace_id = namespace_id;
    this.rule_name = rule_name;
    this.priority = priority;
    this.params_match = params_match;
    this.channel = channel;
    this.template = template;
    this.cooldown_min = cooldown_min;
    this.retry_max_attempts = retry_max_attempts;
    this.recipients = recipients || [];
    this.recipient_channels = recipient_channels || [];
    this.escalation_steps = escalation_steps || [];
    this.enabled = enabled;
    this.created_at = created_at;
  }
}

export const NotificationRuleDeviceType = {
  CAMERA_ALERT: "cameraAlert",
  LOCK_ALARM: "lockAlarm",
  WATCH_ALARM: "watchAlarm",
  EMPTY: "",
};
export class EscalationStep {
  constructor({ after_min, recipient_channels } = {}) {
    this.after_min = after_min;
    this.recipient_channels = recipient_channels || [];
  }
}
/**
 * 创建通知规则
 */
/**
 * NotificationRuleModel represents a notification rule configuration.
 *
 * @property {string|undefined} rule_id - Unique identifier for the rule.
 * @property {string} rule_name - Name of the rule.
 * @property {string} type - Rule type, determines the structure of params_match.
 * @property {number} priority - Priority of the rule.
 * @property {Object} params_match - Parameters to match for the rule.
 * @property {string} template - Template used for notifications.
 * @property {number} cooldown_min - Minimum cooldown in minutes.
 * @property {number} retry_max_attempts - Maximum retry attempts.
 * @property {Array<Object>} recipient_channels - Recipient channels for notifications.
 * @property {Array<Object>} escalation_steps - Steps for escalation.
 * @property {boolean} enabled - Whether the rule is enabled.
 *
 * @constructor
 * @param {Object} model - Initial values for the rule.
 */
export class NotificationRuleModel {
  constructor(model = {}) {
    this.rule_id = model.rule_id || undefined;
    this.rule_name = model.rule_name || "";
    this.type = model.type || NotificationRuleDeviceType.EMPTY; //规则类型，决定了params_match的结构
    this.priority = typeof model.priority === "number" ? model.priority : 0;
    this.params_match = model.params_match || {};
    this.template = model.template || "";
    this.cooldown_min =
      typeof model.cooldown_min === "number" ? model.cooldown_min : 15;
    this.cooldown_by_param = model.cooldown_by_param || "";
    this.retry_max_attempts =
      typeof model.retry_max_attempts === "number"
        ? model.retry_max_attempts
        : 0;
    this.recipient_channels = Array.isArray(model.recipient_channels)
      ? model.recipient_channels
      : [];
    this.escalation_steps = Array.isArray(model.escalation_steps)
      ? model.escalation_steps
      : [];
    this.enabled = typeof model.enabled === "boolean" ? model.enabled : true;
    this.voice_asset_id = getNotificationRuleVoiceAssetId(model); // 可选，语音通知的素材ID
  }
}

function getNotificationRuleVoiceAssetId(model = {}) {
  return (
    model.voice_asset_id ||
    model.voiceAssetId ||
    model.voice_asset?.voice_asset_id ||
    model.voiceAsset?.voice_asset_id ||
    model.voiceAsset?.voiceAssetId ||
    ""
  );
}

/**
 * @param {Partial<NotificationRuleModel>} data
 * @returns {Promise<any>}
 */
export function createNotificationRuleV2(data) {
  return axiosInstance.post("/notification/rules", data);
}

/**
 * @param {string} rule_id
 * @returns {Promise<NotificationRuleListItem>}
 */
export function getNotificationRuleV2(rule_id) {
  return axiosInstance.get("/notification/rules", {
    params: { rule_id },
  });
}

export class ListNotificationRulesResponse {
  constructor({ has_more, next_cursor, ruleList } = {}) {
    this.has_more = has_more;
    this.next_cursor = next_cursor;
    this.ruleList = ruleList || [];
  }
}

/**
 * @param {{cursor?: number, page_size?: number}} params
 * @returns {Promise<ListNotificationRulesResponse>}
 */
export function listNotificationRulesV2(params = { cursor: 0, page_size: 20 }) {
  return axiosInstance.get("/notification/rules", {
    params,
  });
}

/**
 * @param {Partial<NotificationRuleModel>} data
 * @returns {Promise<any>}
 */
export function updateNotificationRuleV2(data) {
  return axiosInstance.put("/notification/rules", data);
}

/**
 * @param {string} rule_id
 * @returns {Promise<any>}
 */
export function deleteNotificationRuleV2(rule_id) {
  return axiosInstance.delete("/notification/rules", {
    params: { rule_id },
  });
}

// 通知中心通知
export class Notification {
  constructor({ content, timestamp, feedback_state, dedupe_key, params } = {}) {
    this.content = content;
    this.timestamp = timestamp;
    this.feedback_state = feedback_state;
    this.dedupe_key = dedupe_key;
    this.params = params;
  }
}

/**
 * @param {Notification} data
 * @returns {Promise<any>}
 */
export function createNotification(data) {
  return axiosInstance.post("/notification/notifications", data, {
    headers: { "X-Namespace-Id": NAEMESPACE_ID },
  });
}

/**
 * @param {any} data
 * @returns {Promise<any>}
 */
export function updateNotificationFeedback(data) {
  return axiosInstance.post("/notification/notifications/feedback", data);
}

/**
 * @param {{rule_id?: string, cursor?: number, page_size?: number}} params
 * @returns {Promise<any>}
 */
export function listNotifications(
  params = { rule_id: undefined, cursor: 0, page_size: 20 }
) {
  return axiosInstance.get("/notification/notifications", {
    params,
  });
}

/**
 * @param {{notification_id: string}} params
 * @returns {Promise<any>}
 */
export function getNotificationHistoryV2(params) {
  return axiosInstance.get("/notification/history", {
    params: params,
  });
}

// 通知中心测试与洞察
/**
 * @param {{phone: string, message: string}} data
 * @returns {Promise<any>}
 */
export function testNotificationWhatsAppV2(data) {
  return axiosInstance.post("/notification/test/whatsapp", data);
}

/**
 * @param {{url: string, message: string, headers?: Object.<string,string>}} data
 * @returns {Promise<any>}
 */
export function testNotificationWebhookV2(data) {
  return axiosInstance.post("/notification/test/webhook", data);
}

/**
 * @param {{"rule_id":"4f8281d3f35b4351be036bb1e3457657","match_rule":true,"notification":{"content":"test","timestamp":"2026-02-13T12:00:00Z","type":"cameraAlert","params":{"deviceId":"1","triggerType":"ppe_detection"}}}} data
 * @returns {Promise<any>}
 */
export function testNotificationRule(data) {
  return axiosInstance.post("/notification/test/rule", data);
}

/**
 * @param {{recipient_channel_id: string, channel: string, message: string}} data
 * @returns {Promise<any>}
 */
export function testNotificationRecipient(data) {
  return axiosInstance.post("/notification/test/recipient-channel", data);
}

/**
 * @param {any} data
 * @returns {Promise<any>}
 */
export function getNotificationInsights(data) {
  return axiosInstance.post("/notification/insights", data);
}

export const NotificationRecipientChannelTypes = {
  WHATS_APP: "whatsapp",
  WHATS_APP_GROUP: "whatsapp_group",
  EMAIL: "email",
  VOICE_CALL: "voice_call",
};

export class NotificationRecipientChannel {
  constructor({
    recipient_channel_id,
    recipient_id,
    channel,
    config,
    created_at,
    recipient_name,
  } = {}) {
    this.recipient_channel_id = recipient_channel_id;
    this.recipient_id = recipient_id;
    this.channel = channel;
    this.config = config || {};
    this.created_at = created_at;
    this.recipient_name = recipient_name;
  }
}

export class ListNotificationRecipientChannelsResponse {
  constructor({ has_more, next_cursor, recipientChannelList } = {}) {
    this.has_more = has_more;
    this.next_cursor = next_cursor;
    this.recipientChannelList = recipientChannelList || [];
  }
}

/**
 * @param {{cursor?: number, page_size?: number}} params
 * @returns {Promise<ListNotificationRecipientChannelsResponse>}
 */
export async function listNotificationRecipientInChannels(
  params = { cursor: 0, page_size: 200 }
) {
  const response = await axiosInstance.get("/notification/recipient-channels", {
    params,
  });
  return response;
}

export class WhatsAppGroupItem {
  constructor({ id, subject, desc, size, owner_phone, created_at } = {}) {
    this.id = id;
    this.subject = subject;
    this.desc = desc;
    this.size = size;
    this.owner_phone = owner_phone;
    this.created_at = created_at;
  }
}

/**
 * 查询 WhatsApp 分组接口
 * @param group_name 分组名称
 * @param owner_phone 群主手机号
 * @returns 分组列表
 */
/**
 * @param {string} group_name
 * @param {string} owner_phone
 * @returns {Promise<{groups: Array<WhatsAppGroupItem>}>}
 */
export async function getWhatsAppGroups(group_name, owner_phone) {
  return await axiosInstance.get("/notification/whatsapp/groups", {
    params: { group_name, owner_phone },
  });
}

// 语音资产管理
/**
 * 上传自定义语音资产（wav/mp3，<=60秒）。
 * @param {FormData} formData 包含 file（必传）和可选 voice_asset_id
 * @returns {Promise<any>}
 */
export function uploadNotificationVoiceAsset(formData) {
  return axiosInstance.post("/notification/voice-assets", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/**
 * 获取语音资产列表。
 * @param {{search?: string, cursor?: number, page_size?: number}} params
 * @returns {Promise<any>}
 */
export function listNotificationVoiceAssets(
  params = { search: "", cursor: 0, page_size: 20 }
) {
  return axiosInstance.get("/notification/voice-assets", {
    params,
  });
}

/**
 * 获取单个语音资产详情。
 * @param {string} voice_asset_id
 * @returns {Promise<any>}
 */
export function getNotificationVoiceAssetDetail(voice_asset_id) {
  return axiosInstance.get("/notification/voice-assets/detail", {
    params: { voice_asset_id },
  });
}
